export var version = '3.6.8';
//# sourceMappingURL=version.js.map